import {
    HttpResponse,
    UserRoleModel,
    QueryModel,
    RequestParams,
    UserRoleModelIEnumerableApiResultSuccess,
    UserRoleModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class UserRolesDataService implements CrudService<UserRoleModel, UserRoleModel> {
    getAll(query: CrudDataQuery<UserRoleModel>): Promise<CrudEnumerableResponse<UserRoleModel>> {
        return ApiService.api.getUserRoleBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<UserRoleModel>): Promise<CrudEnumerableResponse<UserRoleModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<UserRoleModel>> {
        return ApiService.api.getUserRoleById(id, params);
    }

    create(item: UserRoleModel, params?: RequestParams): Promise<CrudResponse<UserRoleModel>> {
        return ApiService.api.insertUserRole(item, params);
    }

    update(item: UserRoleModel, params?: RequestParams): Promise<UserRoleModel> {
        return ApiService.api.updateUserRole(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<UserRoleModel> {
        return ApiService.api.patchUserRole(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<UserRoleModel>): Promise<CrudEnumerableResponse<UserRoleModel>> {
        return ApiService.api.deleteUserRoles(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationUserRole(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<UserRoleModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: UserRoleModel, params?: RequestParams): Promise<CrudResponse<UserRoleModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
